"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FlexForm = _interopRequireDefault(require("../../FlexibleComponents/FlexForm/FlexForm"));
var GetInTouch = function GetInTouch(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'tyw' : _ref$brand;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-left text-md"
  }, brand === 'qd' ? "ADDRESS" : 'GET IN TOUCH'), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/_react["default"].createElement(_FlexForm["default"], {
    template: "".concat(brand, "_contact_us")
  })));
};
var _default = exports["default"] = GetInTouch;